import React from 'react';

export const TradersSayTitle = () => (
  <>
    {/* Заголовок */}
    <div
      style={{
        position: 'absolute',
        width: 900,
        height: 76,
        left: 'calc(50% - 887px / 2 + 0.5px)',
        top: 2557,
        fontFamily: `'SF Pro', sans-serif`,
        fontStyle: 'normal',
        fontWeight: 510,
        fontSize: 64,
        lineHeight: '76px',
        color: '#FFFFFF',
        textAlign: 'center',
      }}
    >
      What our traders are saying
    </div>

    {/* Подчёркивание */}
    <div
      style={{
        position: 'absolute',
        width: 757,
        height: 8,
        left: 'calc(50% - 757px / 2 + 0.5px)',
        top: 2635,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
        borderRadius: 50,
      }}
    />
  </>
);